import React from 'react'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import AccountListUI from '../../../components/superUser/account/AccountListUI.js'
import AccountCreateModalSF from '../../../components/superUser/account/AccountCreateModalSF.js'
import TdsStatusUpdateModalSF from '../../../components/superUser/account/TdsStatusUpdateModalSF.js'

const AccountListPageUI = ({ context, errorList, accountList, filteredAccountList,
  onDeleteClick, deleteSubmitted, onRefreshClick, onRowClick,
  onLoginClick, loginSubmitted, onOpenTdsStatusUpdateModal, onCancelTdsStatusUpdateModal, onTdsStatusUpdated,
  tdsStatusUpdateMode, selectedTdsAccount, selectedAccountId,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  onCreateAccountClick, createAccountMode,
  onCancelCreateAccount, account, onTypeChange
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_acc_l' topnav='accounts'
    centered={!accountList && !errorList || accountList && accountList.length === 0}
    page='accounts' onTypeChange={onTypeChange}
  >
    {
      !accountList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountList &&
      <div>
        <AccountListUI context={context} accountList={filteredAccountList}
          onRowClick={onRowClick}
          onRefreshClick={onRefreshClick}
          onDeleteClick={onDeleteClick} deleteSubmitted={deleteSubmitted}
          onLoginClick={onLoginClick} loginSubmitted={loginSubmitted}
          onOpenTdsStatusUpdateModal={onOpenTdsStatusUpdateModal}
          selectedAccountId={selectedAccountId}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
          onCreateAccountClick={onCreateAccountClick}
        />
      </div>
    }
    <TdsStatusUpdateModalSF
      context={context}
      account={selectedTdsAccount}
      updateMode={tdsStatusUpdateMode}
      onCancelClick={onCancelTdsStatusUpdateModal}
      onTdsStatusUpdated={onTdsStatusUpdated}
    />
    <AccountCreateModalSF context={context} createAccountMode={createAccountMode} onCancelCreateAccount={onCancelCreateAccount}
      account={account} onRefreshClick={onRefreshClick} />
  </SuperUserHomePageUI>

export default AccountListPageUI
